import type { DataTableColumn } from "../../ui/DataTable/types";

export const adminAuditColumns: DataTableColumn[] = [
  { key: "admin", label: "Admin", className: "px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted" },
  { key: "action", label: "Action", className: "px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted" },
  { key: "target", label: "Target", className: "px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted" },
  { key: "reason", label: "Reason", className: "px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted" },
  { key: "createdAt", label: "Created", className: "px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted" },
];
